import { ITextData } from './TextData';
import { EEnvironment } from '../config';

const environmentType = process.env.REACT_APP_ENVIRONMENT_TYPE as EEnvironment;

const PRODUCT_NAME =
  !environmentType || environmentType === 'prod'
    ? 'Loimua Asiakasnet'
    : `(${environmentType}) Loimua Asiakasnet`;

const contact = `asiakaspalvelu@loimua.fi tai puh. 020 690 035 ma-pe 9-17 `;

const loimuaTextData: ITextData = {
  commonTexts: {
    productName: `${PRODUCT_NAME}`,
    signIn: `Kirjaudu sisään ${PRODUCT_NAME}tiin`,
    signUp: `Rekisteröidy ${PRODUCT_NAME}tiin`,
    extranetButton: 'Loimua Asiakasnettiin',
    passwordRequirements: `Salasanan täytyy olla vähintään 8 merkkiä pitkä, ja sen täytyy
    sisältää sekä isoja että pieniä kirjaimia sekä vähintään yksi numero
    ja erikoismerkki.`,
  },
  authStateTitles: {
    signin: `${PRODUCT_NAME} - Kirjautuminen`,
    signup: `${PRODUCT_NAME} - Rekisteröityminen`,
    signout: `${PRODUCT_NAME} - Uloskirjautuminen`,
    loading: `${PRODUCT_NAME} - Ladataan`,
    forgotpassword: `${PRODUCT_NAME} - Palauta salasana`,
    resettingpassword: `${PRODUCT_NAME} - Vaihda salasana`,
    confirmSignUp: `${PRODUCT_NAME} - Vahvista käyttäjätunnus`,
  },
  signUpInfoBox: {
    text: `Uudistimme Loimua Asiakasnet -palvelun kirjautumisjärjestelmän entistä turvallisemmaksi. Aiempi käyttäjätunnuksesi toimii, mutta sinun tulee uusia salasanasi. Yksityisasiakkaiden kirjautuminen onnistuu suomalaisilla pankkitunnuksilla tai mobiilivarmenteella. Yritysasiakkaiden tulee syöttää y-tunnus, asiakasnumero ja käyttöpaikka ensimmäisen kirjautumisen yhteydessä.`,
  },
  profileSettings: {
    pageTitle: `${PRODUCT_NAME} - Päivitä käyttäjätiedot`,
    headerTitle: 'Käyttäjätietojen muuttaminen',
    instructions: `Käyttäjätietojen muutos vaikuttaa vain palvelun käyttämiseen ja kirjautumiseen.
      Huom! Tietojen päivittyminen ${PRODUCT_NAME}tiin saattaa vaatia uuden kirjautumisen.`,
  },
  changePassword: {
    pageTitle: `${PRODUCT_NAME} - Vaihda salasana`,
    headerTitle: 'Vaihda salasana',
  },
  signicatUndone: {
    pageTitle: `${PRODUCT_NAME} - Tunnistaudu vahvasti`,
    headerTitle: `${PRODUCT_NAME}in käyttöönotto 1/3 - Tunnistaudu vahvasti`,
    instructions: [
      `Tervetuloa ${PRODUCT_NAME} -palveluun.`,
      `Tunnistaudu palveluun ensimmäisellä kerralla pankkitunnuksilla tai mobiilivarmenteella.`,
      `Jatkossa voit kirjautua sähköpostiosoitteella ja salasanalla.`,
    ],
    beginSignicat: 'Aloita tunnistautuminen',
    loading: 'Ladataan...',
  },
  deleteUser: {
    pageTitle: `${PRODUCT_NAME} - Poista käyttäjätunnus`,
    headerTitle: 'Poista käyttäjätunnus',
    confirmText: `Ymmärrän, että poistettuani käyttäjätunnukseni, en pääse kirjautumaan enää ${PRODUCT_NAME}tiin.`,
    instructions: [
      `Käyttäjätunnuksen poistamisen jälkeen et pääse kirjautumaan enää ${PRODUCT_NAME} -palveluun. Voit ottaa ${PRODUCT_NAME} -palvelun käyttöösi rekisteröitymällä palveluun uudelleen.`,
      `Huom. Käyttäjätunnuksen poistaminen ${PRODUCT_NAME} -palvelusta ei katkaise verkkopalvelusopimuksiasi
      tai poista asiakkuuksiasi Loimuan asiakastietojärjestelmästä.
      Tehdäksesi muutoksia verkkopalvelusopimukseesi tai asiakastietoihisi Louimuassa,
      ole yhteydessä asiakaspalveluumme: ${contact}`,
    ],
  },
  addOrganization: {
    pageTitle: `${PRODUCT_NAME} - Yrityksen lisääminen`,
    headerTitle: 'Yrityksen lisääminen',
    generalInstructions: `Liittämällä yrityksesi y-tunnuksen käyttäjätiliisi, saat kaikki y-tunnukseesi liitetyt asiakkuudet ja käyttöpaikat kerralla näkyviin. Tämän
    jälkeen myös kaikki mahdolliset uudet asiakkuudet päivittyvät näkyviin automaattisesti eikä sinun tarvitse lisätä niitä erikseen. Mikäli sinulla on useampi y-tunnus,
    voit liittää jokaiseen y-tunnukseesi liittyvät asiakkuudet samalla tavalla. `,
    specificInstructions: [
      ` Y-tunnuksen lisäksi tarvitset yrityksesi verkkopalvelulaskulta
    löytyvän asiakasnumeron sekä käyttöpaikkatunnuksen`,
      ` Järjestelmä hakee automaattisesti kaikki kyseiseen y-tunnukseen
    liittyvät asiakkuudet sekä niihin liittyvät käyttöpaikat Loimua Asiakasnet -palveluun.`,
    ],
    customerNumberFormat:
      'Asiakasnumero on 7-numeroinen luku, joka alkaa joko numerolla 1 tai 7. Löydät asiakasnumerosi verkkopalvelulaskusi oikeasta yläkulmasta, kohdasta ”Asiakasnumero” tai uutena asiakkaana liittymissopimuksesi oikeasta yläkulmasta kohdasta ”Asiakastunnus”.',
    meteringPointOrConnectionNumberFormat: [
      'Löydät käyttöpaikkatunnuksesi laskultasi.',
    ],
    checkField1Name: 'Asiakasnumero tai asiakastunnus',
    checkField2Name: 'Käyttöpaikkatunnus',
  },
  homePage: {
    pageTitle: `${PRODUCT_NAME} - Käyttäjätilin asetukset`,
    headerTitle: 'Käyttäjätilin asetukset',
    instructions: {
      personWithCustomerships: [
        `Käyttäjätiliisi on liitetty seuraavat asiakkuudet`,
        `Voit halutessasi muokata ${PRODUCT_NAME} -palvelussa näytettäviä tietoja piilottamalla asiakkuuden ”Piilota asiakkuus” -painikkeella.
        Piilotetut asiakkuudet voi liittää takaisin milloin tahansa.
        Huomaa, että piilottamisella ei ole vaikutusta verkkopalvelusopimuksesi voimassaoloon tai muihin sopimustietoihisi,
        vaan sen avulla voit ainoastaan muokata ${PRODUCT_NAME} -palvelussa näytettäviä tietoja.`,
        `Jos kaikkia sinulle kuuluvia asiakkuuksiasi ei näy,
        pyydämme ystävällisesti olemaan yhteydessä asiakaspalveluumme: ${contact}.`,
      ],
      personWithoutCustomerships: [
        `Käyttäjätiliisi ei ole tällä hetkellä liitetty yhtäkään asiakkuutta.`,
        `Jos tarvitset apua,
        pyydämme ystävällisesti olemaan yhteydessä asiakaspalveluumme: ${contact}.`,
      ],
      organizationWithCustomerships: [
        `Käyttäjätiliisi on liitetty seuraavat asiakkuudet.`,
        `Voit halutessasi muokata Loimua Asiakasnet -palvelussa näytettäviä tietoja piilottamalla asiakkuuden ”Piilota asiakkuus” -painikkeella.
        Piilotetut asiakkuudet voi liittää takaisin milloin tahansa.
        Huomaa, että piilottamisella ei ole vaikutusta verkkopalvelusopimuksesi voimassaoloon tai muihin sopimustietoihisi,
        vaan sen avulla voit ainoastaan muokata Loimua Asiakasnet -palvelussa näytettäviä tietoja.`,
        `Jos kaikkia y-tunnukseenne liittyviä asiakkuuksia ei löytynyt,
        pyydämme ystävällisesti ottamaan yhteyttä asiakaspalveluumme: ${contact}.`,
      ],
      organizationWithoutCustomerships: [
        `Käyttäjätiliisi ei ole liitetty yhtäkään asiakkuutta.`,
        `Voit käydä liittämässä käyttäjätiliisi yritysasiakkuuden syöttämällä tarvittavat tiedot 'Lisää yritys'-sivulla.`,
      ],
    },
  },
  verifyCustomerships: {
    found: {
      pageTitle: `${PRODUCT_NAME} - Löydetyt asiakkuudet`,
      headerTitle: `${PRODUCT_NAME}in käyttöönotto 2/3 - Löydetyt asiakkuudet`,
      confirmButton: `Vahvista ja siirry ${PRODUCT_NAME}tiin`,
      instructions: [
        `Tässä ovat asiakkuudet, jotka vahva tunnistautuminen yhdisti sinuun. Jos huomaat tiedoissa virheitä, pyydämme keskeyttämään käyttöönoton ja ottamaan yhteyttä asiakaspalveluun.`,
        `Jos asiakkuuksiasi ei löytynyt tai tiedot ovat puutteellisia, pyydämme ystävällisesti ottamaan yhteyttä asiakaspalveluumme: ${contact}.`,
        `Jos haluat tarkastella ${PRODUCT_NAME} -palvelussa jonkun toisen henkilön tietoja,
        pyydämme toimittamaan häneltä vapaamuotoisen valtuutuksen osoitteeseen asiakaspalvelu@loimua.fi`,
      ],
    },
    notFound: {
      pageTitle: `${PRODUCT_NAME} - Ei asiakkuuksia`,
      headerTitle: `${PRODUCT_NAME}in  käyttöönotto - Asiakkuuksia ei löytynyt`,
      confirmButton: '',
      instructions: [
        `Vahva tunnistautuminen ei yhdistänyt asiakkuuksia sinuun.`,
        `Tämä voi liittyä siihen, että asiakastietosi Loimuan asiakastietojärjestelmässä ovat puutteelliset.`,
        `Pyydämme ystävällisesti ottamaan yhteyttä asiakaspalveluumme asian selvittämiseksi: ${contact}.`,
        `Jos haluat tarkastella Loimua Asiakasnet -palvelussa jonkun toisen henkilön tietoja,
        pyydämme toimittamaan häneltä vapaamuotoisen valtuutuksen osoitteeseen asiakaspalvelu@loimua.fi`,
      ],
    },
  },
  manageCustomerAccounts: {
    pageTitle: `${PRODUCT_NAME} - Asiakkaan käyttäjätilin hallinta`,
    headerTitle: 'Asiakkaan käyttäjätilin hallinta',
  },
  launchpad: {
    pageTitle: `${PRODUCT_NAME} - Launchpad`,
    headerTitle: 'Launchpad',
  },
};

export default loimuaTextData;
